package com.tovtalk.data.local

import com.tovtalk.database.TovTalkDatabase
import com.tovtalk.database.PostEntity
import com.tovtalk.database.UserEntity

/**
 * Local Data Source - SQLDelight wrapper
 */
class LocalDataSource(
    databaseDriverFactory: DatabaseDriverFactory
) {
    private val database = TovTalkDatabase(databaseDriverFactory.createDriver())
    private val userQueries = database.userQueries
    private val postQueries = database.postQueries
    
    // User Operations
    fun insertUser(user: UserEntity) {
        userQueries.insertUser(user)
    }
    
    fun getUserById(id: Long): UserEntity? {
        return userQueries.getUserById(id).executeAsOneOrNull()
    }
    
    fun getCurrentUser(): UserEntity? {
        return userQueries.getCurrentUser().executeAsOneOrNull()
    }
    
    fun updateUser(id: Long, fullname: String, username: String, bio: String?, profilePhoto: String?) {
        userQueries.updateUser(fullname, username, bio, profilePhoto, id)
    }
    
    fun deleteAllUsers() {
        userQueries.deleteAllUsers()
    }
    
    fun getAllUsers(): List<UserEntity> {
        return userQueries.getAllUsers().executeAsList()
    }
    
    // Post Operations
    fun insertPost(post: PostEntity) {
        postQueries.insertPost(post)
    }
    
    fun getPostById(id: Long): PostEntity? {
        return postQueries.getPostById(id).executeAsOneOrNull()
    }
    
    fun getPostsByType(postType: Long, limit: Long): List<PostEntity> {
        return postQueries.getPostsByType(postType, limit).executeAsList()
    }
    
    fun getUserPosts(userId: Long, postType: Long, limit: Long): List<PostEntity> {
        return postQueries.getUserPosts(userId, postType, limit).executeAsList()
    }
    
    fun deletePost(id: Long) {
        postQueries.deletePost(id)
    }
    
    fun updatePostLike(id: Long, isLiked: Long, likes: Long) {
        postQueries.updatePostLike(isLiked, likes, id)
    }
    
    fun updatePostSave(id: Long, isSaved: Long, saves: Long) {
        postQueries.updatePostSave(isSaved, saves, id)
    }
    
    fun deleteAllPosts() {
        postQueries.deleteAllPosts()
    }
    
    fun getAllPosts(): List<PostEntity> {
        return postQueries.getAllPosts().executeAsList()
    }
}
